const name = 'circle-3';


const contents = `
<circle cx="31" cy="41" r="29"/>
<path d="M30.834 55.5a31.73 31.73 0 01-5.22-.414c-1.657-.276-3.314-.801-4.971-1.575l1.574-4.142c1.436.607 2.79 1.05 4.06 1.325a18.28 18.28 0 003.894.415c1.16 0 2.1-.139 2.818-.415.718-.276 1.256-.607 1.615-.994.36-.387.608-.815.746-1.284.138-.47.207-.926.207-1.367 0-1.27-.442-2.251-1.326-2.942-.883-.69-2.347-1.036-4.391-1.036h-3.646V38.93h3.397c1.878 0 3.26-.429 4.143-1.285.884-.856 1.326-1.809 1.326-2.858 0-.829-.331-1.699-.994-2.61-.663-.912-1.989-1.367-3.977-1.367-1.381 0-2.666.151-3.853.455a17.203 17.203 0 00-3.439 1.285l-1.491-4.06c1.767-.774 3.48-1.299 5.137-1.575a28.768 28.768 0 014.723-.414c2.817 0 5.095.621 6.835 1.864 1.74 1.243 2.61 3.107 2.61 5.593 0 1.602-.441 2.928-1.325 3.977-.884 1.05-2.43 1.878-4.64 2.486v.497c2.706.442 4.502 1.243 5.385 2.403.884 1.16 1.326 2.541 1.326 4.143 0 2.596-.884 4.585-2.651 5.966-1.768 1.38-4.392 2.071-7.872 2.071z" fill="#FFF"/>
`;


/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: '3',
};

export default icon;
